import { RestaurantRawMaterialCategoryDTO } from '../../../../types/restaurant/RestaurantRawMaterialCategoryTypes';

import RawMaterialCategoryCard from './RawMaterialCategoryCard';

interface RawMaterialCategoryGridProps {
  categories: RestaurantRawMaterialCategoryDTO[];
  onEdit: (category: RestaurantRawMaterialCategoryDTO) => void;
  onToggleActive: (category: RestaurantRawMaterialCategoryDTO) => void;
}

const RawMaterialCategoryGrid = ({
  categories,
  onEdit,
  onToggleActive,
}: RawMaterialCategoryGridProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 p-5 md:hidden">
      {categories.map((category) => (
        <RawMaterialCategoryCard
          key={category.id}
          category={category}
          onEdit={onEdit}
          onToggleActive={onToggleActive}
        />
      ))}
    </div>
  );
};

export default RawMaterialCategoryGrid;
